import * as api from './api'
import { THREE_MINUTES } from '@/constants/time'

import { checkTtlDate } from '@/helper'

export default {
  async loadData ({ commit, state }, { force = false } = {}) {
    const isNeedUpdate = checkTtlDate({
      timeUpdate: state.lastDateUpdated,
      ttlTime: THREE_MINUTES
    })

    if (!force && state.data.length && !isNeedUpdate) {
      return
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      commit('setData', data.data)
      commit('setLastDateUpdated')

      return { data: data.data }
    }

    return { error: data.data }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.unshift(data.data)

      commit('setData', newData)

      return { data: newData }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            ...payloadData
          }
        }

        return item
      })

      commit('setData', newData)

      return { data: newData }
    }

    return { error: data.data }
  },
  async remove (_, { repairId, operationId }) {
    const { data } = await api.remove(repairId, operationId) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data.data }
  }
}